<template>
    <div class="patient-view record">
        <FileCard :patient="patient"></FileCard>
        <RecordCard :patient="patient"></RecordCard>
        <SurveyCard :patient="patient" :is-survey="true"></SurveyCard>
    </div>
</template>

<script>
import PatientView from '..'

export default {
    name: 'patient-record',
    extends: PatientView,


}
</script>

<style>

</style>